import {defaultSerializeQueryArgs} from '@reduxjs/toolkit/query/react';
import {api} from '~/ViewInvitation/api/api';

const getPhotosQuery = ({eventId, perPage, cursor, guestId, includeCount = false}) => {
  const queryParams = new URLSearchParams();
  if (perPage) queryParams.append('per_page', perPage || 3);
  if (cursor) queryParams.append('cursor', cursor);
  if (guestId) queryParams.append('guest_id', guestId);
  if (includeCount) queryParams.append('include_count', `${includeCount}`);
  const queryString = queryParams.toString();
  const queryStringParams = queryString && `?${queryString}`;
  return {
    url: `/ajax/event/${eventId}/posts/photos${queryStringParams}`,
  };
};

export const photosApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPhotos: builder.query({
      query: getPhotosQuery,
      providesTags: ['Photo'],
    }),
    // TODO: implement native infinite query: https://github.com/reduxjs/redux-toolkit/releases/tag/v2.6.0
    getPhotosInfinite: builder.query({
      query: getPhotosQuery,
      providesTags: ['Photo'],
      serializeQueryArgs: ({queryArgs, endpointDefinition, endpointName}) => {
        const {eventId, guestId, perPage} = queryArgs;

        return defaultSerializeQueryArgs({
          endpointName,
          queryArgs: {eventId, guestId, perPage},
          endpointDefinition,
        });
      },
      merge: (currentCacheData, responseData) => {
        responseData.objects.forEach((newPhoto) => {
          if (!currentCacheData.objects.some((photo) => photo.id === newPhoto.id))
            currentCacheData.objects.push(newPhoto);
        });
        /* eslint-disable no-param-reassign */
        currentCacheData.cursor = responseData.cursor;
        currentCacheData.data_layer = responseData.data_layer;
        currentCacheData.more = responseData.more;
        currentCacheData.total_count = responseData.total_count;
        /* eslint-enable no-param-reassign */
      },
      forceRefetch({currentArg, previousArg}) {
        return (
          currentArg?.eventId !== previousArg?.eventId ||
          currentArg?.perPage !== previousArg?.perPage ||
          currentArg?.guestId !== previousArg?.guestId ||
          currentArg?.cursor !== previousArg?.cursor
        );
      },
    }),
    deletePhotos: builder.mutation({
      query: ({id, guestId, eventId}) => ({
        url: `/ajax/event/${eventId}/posts/${id}/?gid=${guestId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Photo'],
    }),
    postPhotos: builder.mutation({
      query: ({photos, eventId, guestId}) => ({
        url: `/ajax/event/${eventId}/posts/photos/?gid=${guestId}`,
        method: 'POST',
        body: {
          photo_ids: photos,
        },
      }),
    }),
  }),
});

export const {
  useGetPhotosQuery,
  useLazyGetPhotosQuery,
  useGetPhotosInfiniteQuery,
  useDeletePhotosMutation,
  usePostPhotosMutation,
} = photosApi;
